import { useEffect, useState } from 'react';

export function useScrollPercentage() {
    const [hasQueuedAnimation, setQueuedAnimation] = useState(false);
    const [scrollPercentage, setScrollPercentage] = useState(0);

    function calculateScroll() {
        const windowScroll = document.body.scrollTop || document.documentElement.scrollTop;
        const height =
            document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrolled = (windowScroll / height) * 100;
        return scrolled;
    }

    useEffect(() => {
        function handleScroll() {
            if (!hasQueuedAnimation) {
                window.requestAnimationFrame(() => {
                    setScrollPercentage(calculateScroll());
                    setQueuedAnimation(false);
                });
                setQueuedAnimation(true);
            }
        }

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [hasQueuedAnimation]);
    return scrollPercentage;
}
